import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MatFormField, MatInput, MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';
import { InputAutoCompleteOption } from './input-autocomplete-option';
import { AbstractInputComponent } from '../abstract-input.component';
import { OnlyAlphabeticDirective } from '../../../../utils/directives/only-alphabetic-directive';

@Component({
  selector: 'logpn-input-autocomplete',
  templateUrl: './input-autocomplete.component.html',
  styleUrls: ['./input-autocomplete.component.scss'],
  imports: [
    MatFormField,
    MatInput,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatAutocompleteModule,
    MatInputModule,
    MatIcon,
    MatIconButton,
    TranslocoPipe,
    OnlyAlphabeticDirective,
  ],
})
export class InputAutocompleteComponent extends AbstractInputComponent {
  @Input() appearance: 'fill' | 'outline' = 'outline';
  @Input() minlength: number = 3;
  @Input() override maxLength: number = 3;
  @Input() idEditMode: boolean = true;

  @Output() selectionChange = new EventEmitter<any>();
  @Input() items: InputAutoCompleteOption[] | null = null;

  override defaultErrorMessages(): { [key: string]: string } {
    return {
      minlength: 'forms.errors.autocomplete.minlength',
      maxlength: 'forms.errors.autocomplete.maxlength',
      ...this.defaultRequiredErrorMessage(),
    };
  }

  onOptionSelected(item: InputAutoCompleteOption) {
    this._control.setValue(item);
    this.selectionChange.emit(item);
  }

  clearInput() {
    this._control.setValue('');
    this.selectionChange.emit('');
    this.items = [];
  }

  displayLabel(item: InputAutoCompleteOption | null): string {
    return item?.label ?? '';
  }
}
